import { registerBuiltinComponents } from './core/registerBuiltinComponents';

registerBuiltinComponents();

export * from './core';
export * from './components';
export * from './game-objects';
